import { jsxs as l, jsx as s, Fragment as S } from "react/jsx-runtime";
import { useMemo as b, cloneElement as x } from "react";
import { c as f } from "./tw-cn-mXgPecoF.mjs";
import { D as y } from "./dot-badge-tMztb4kJ.mjs";
import { c as d } from "./index-BpNK5r1N.mjs";
const w = d(["inline-flex text-text-neutral-main w-full"], {
  variants: {
    theme: {
      default: "bg-static-white",
      ghost: "bg-transparent",
      transparent: "bg-transparent !text-static-white"
    },
    subTitle: {
      true: "min-h-68",
      false: "min-h-50"
    },
    icon: {
      true: "flex",
      false: ""
    },
    aside: {
      true: "gap-8 w-full justify-between",
      false: ""
    }
  },
  defaultVariants: {
    theme: "default",
    subTitle: !1,
    icon: !1,
    aside: !1
  }
}), H = d(["relative"], {
  variants: {
    mobileSize: {
      default: "typography-subtitle-18-bold",
      small: "typography-subtitle-16-bold"
    },
    showDotBadge: {
      true: "mr-6",
      false: ""
    }
  },
  defaultVariants: {
    mobileSize: "small",
    showDotBadge: !1
  }
}), v = ({
  title: r,
  subTitle: e = null,
  theme: m = "default",
  icon: t,
  aside: a,
  mobileSize: i = "default",
  showDotBadge: n = !1,
  className: o,
  ...p
}) => {
  const h = w({
    theme: m,
    subTitle: !!e,
    icon: !!t,
    aside: !!a
  }), c = H({ mobileSize: i, showDotBadge: n }), u = b(() => t ? x(t, { className: "size-20" }) : null, [t]);
  return !r && !e && !u ? null : /* @__PURE__ */ l("div", { className: f(h, o), ...p, children: [
    /* @__PURE__ */ l("div", { className: "flex w-full flex-col justify-center", children: [
      /* @__PURE__ */ l("div", { className: f("flex items-center", { "shrink-0": !!e }), children: [
        /* @__PURE__ */ l("span", { className: c, children: [
          r,
          !!n && /* @__PURE__ */ s(y, {})
        ] }),
        u
      ] }),
      (!!e || !!u) && /* @__PURE__ */ s("div", { className: f("mt-2 flex typography-body-13-regular"), children: e })
    ] }),
    !!a && /* @__PURE__ */ s("div", { className: "flex items-center", children: a })
  ] });
};
v.displayName = "NDS.FixedSubHeader";
const j = d(["inline-flex justify-center truncate"], {
  variants: {
    subTitle: {
      true: "flex flex-col h-68 justify-center",
      false: "items-center typography-subtitle-18-bold h-50"
    },
    isTransparent: {
      true: "bg-transparent text-static-white",
      false: "bg-static-white text-text-neutral-main"
    },
    isTransparentBg: {
      true: "bg-transparent"
    },
    icon: {
      true: "flex",
      false: ""
    },
    aside: {
      true: "gap-8 w-full",
      false: ""
    },
    showDotBadge: {
      true: "pr-6",
      false: ""
    }
  },
  defaultVariants: {
    subTitle: !1,
    isTransparent: !1,
    isTransparentBg: !1,
    icon: !1,
    aside: !1
  }
}), z = d(["typography-subtitle-16-bold relative flex max-w-[800px] items-center "]), N = ({
  title: r,
  subTitle: e = null,
  isTransparent: m = !1,
  isTransparentBg: t = !1,
  icon: a,
  aside: i,
  showDotBadge: n = !1,
  ...o
}) => {
  const p = j({
    subTitle: !!e,
    isTransparent: m,
    isTransparentBg: t,
    icon: !!a,
    aside: !!i,
    showDotBadge: n
  }), h = z(), c = b(() => a ? x(a, { className: "size-20" }) : null, [a]);
  return !r && !e && !c ? null : /* @__PURE__ */ l("div", { className: p, ...o, children: [
    /* @__PURE__ */ l("div", { className: h, children: [
      r,
      !!n && /* @__PURE__ */ s(y, {})
    ] }),
    (!!e || !!c) && /* @__PURE__ */ l(S, { children: [
      /* @__PURE__ */ s("div", { className: "mt-2 flex max-w-[440px] truncate typography-body-13-regular", children: e }),
      c
    ] }),
    !!i && /* @__PURE__ */ s("div", { className: "ml-auto flex-none", children: i })
  ] });
};
N.displayName = "NDS.SubHeaderSmall";
const T = d(
  ["inline-flex pc:px-0 py-4 pc:items-center pc:typography-headline-24-bold text-text-neutral-main w-full"],
  {
    variants: {
      theme: {
        default: "bg-static-white",
        ghost: "bg-transparent",
        transparent: "bg-transparent !text-static-white"
      },
      subTitle: {
        true: "min-h-68 pc:min-h-80",
        false: "min-h-50 pc:min-h-80"
      },
      icon: {
        true: "flex",
        false: ""
      },
      aside: {
        true: "gap-8 pc:gap-16 w-full justify-between",
        false: ""
      }
    },
    defaultVariants: {
      theme: "default",
      subTitle: !1,
      icon: !1,
      aside: !1
    }
  }
), D = d(["relative pc:typography-headline-24-bold"], {
  variants: {
    mobileSize: {
      default: "typography-subtitle-18-bold",
      small: "typography-subtitle-16-bold"
    },
    showDotBadge: {
      true: "mr-6",
      false: ""
    }
  },
  defaultVariants: {
    mobileSize: "default",
    showDotBadge: !1
  }
}), g = ({
  title: r,
  subTitle: e = null,
  theme: m = "default",
  icon: t,
  aside: a,
  mobileSize: i = "default",
  showDotBadge: n = !1,
  className: o,
  ...p
}) => {
  const h = T({
    theme: m,
    subTitle: !!e,
    icon: !!t,
    aside: !!a
  }), c = D({ mobileSize: i, showDotBadge: n }), u = b(() => t ? x(t, { className: "size-20 pc:size-24" }) : null, [t]);
  return !r && !e && !u ? null : /* @__PURE__ */ l("div", { className: f(h, o), ...p, children: [
    /* @__PURE__ */ l("div", { className: "flex w-full flex-col justify-center pc:flex-row pc:items-center pc:justify-start", children: [
      /* @__PURE__ */ l("div", { className: f("flex items-center", { "shrink-0 pc:max-w-[800px]": !!e }), children: [
        /* @__PURE__ */ l("span", { className: c, children: [
          r,
          !!n && /* @__PURE__ */ s(y, {})
        ] }),
        u
      ] }),
      (!!e || !!u) && /* @__PURE__ */ s(
        "div",
        {
          className: f("mt-2 flex typography-body-13-regular pc:ml-20 pc:mt-0 pc:typography-subtitle-20-regular"),
          children: e
        }
      )
    ] }),
    !!a && /* @__PURE__ */ s("div", { className: "flex items-center", children: a })
  ] });
};
g.Small = N;
g.Fixed = v;
g.displayName = "NDS.SubHeader";
export {
  g as S
};
